module.exports = __webpack_public_path__ + "0636f8018aa4b76a27e994fa90dedec3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/official-icons/invite-s.png
// module id = 1701
// module chunks = 0